import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';

interface deleteRevokeLicenseKeyProps {
  licenseKeyId: string;
}

interface deleteRevokeLicenseKeyResponse {
  licenseKeyId: string;
}

/** 라이선스 키 폐기 */
export const deleteRevokeLicenseKey = async ({
  licenseKeyId,
}: deleteRevokeLicenseKeyProps) => {
  const { data } = await api.delete<
    ApiResponseType<deleteRevokeLicenseKeyResponse>
  >(`/api/web/admins/license-keys/${licenseKeyId}`);

  return data;
};
